module.exports = __webpack_public_path__ + "img/Hekmat.0b5b9e60.svg";